var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.001,
    height: 35.987,
    viewBox: "0 0 40.001 35.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1k3vpzhtda"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 716",
    style: {
      fill: "none"
    },
    d: "M0 0h7.357v16.792H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3jjksgclmb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 621",
    style: {
      fill: "none"
    },
    d: "M0 0h23v32H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2022"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2021"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 341"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 615",
    d: "M253.814 475.63h20.336v1.379c0 .47-.034.518-.486.693-.03 0-.061-.007-.091-.007h-19.726a1.531 1.531 0 0 0-1.028 2.708 1.948 1.948 0 0 0 1.267.392q9.65-.013 19.3-.006c.091 0 .183-.005.274-.008.406.139.492.259.491.679v.849a.5.5 0 0 1-.448.546.488.488 0 0 1-.061 0c-.081.007-.163 0-.244 0q-9.621 0-19.241.006a3.885 3.885 0 0 1-3.036-1.271 3.245 3.245 0 0 1-.924-2.117l-.018-.515v-.068l.021-.238a.39.39 0 0 0 .054-.1 3.637 3.637 0 0 1 3.556-2.928",
    transform: "translate(-234.164 -446.883)",
    style: {
      fill: "#1fb04b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 616",
    d: "M253.874 251.149a3.638 3.638 0 0 0-3.561 2.928.386.386 0 0 1-.054.1c0-.111-.012-.222-.012-.332q0-10.844-.006-21.691a3.607 3.607 0 0 1 .677-2.239 3.487 3.487 0 0 1 2.956-1.5v22.736",
    transform: "translate(-234.219 -222.402)",
    style: {
      fill: "#148230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 617",
    d: "M294.308 501.212c-.091 0-.183.008-.274.008q-9.649 0-19.3.006a1.949 1.949 0 0 1-1.267-.392 1.531 1.531 0 0 1 1.028-2.708q9.863-.009 19.726 0a.4.4 0 0 1 .091.007v3.082",
    transform: "translate(-254.811 -467.311)",
    style: {
      fill: "#cfe2d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 618",
    d: "M250.046 511.2v.068a.258.258 0 0 1-.02-.05c0-.005.012-.013.019-.02",
    transform: "translate(-234.026 -479.18)",
    style: {
      fill: "#c3d9e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 675",
    transform: "translate(16 6)",
    style: {
      fill: "none"
    },
    d: "M0 0h23.999v29.987H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 646",
    d: "M310.047 229.394a1.778 1.778 0 0 0-.149-.718 1 1 0 0 0-1.04-.523h-18.937c-.071 0-.142.011-.213.011V250.9h20.337c0-.334.012-.667.012-1q.006-10.254-.006-20.508",
    transform: "translate(-270.054 -222.155)",
    style: {
      fill: "#4fba6f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 368"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 367",
    transform: "translate(25.699 9.021)",
    style: {
      clipPath: "url(#1k3vpzhtda)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 647",
    d: "M0 33.006c.07-.311.128-.6.207-.885.015-.053.109-.1.175-.12.616-.214.76-.238 1.382-.431A9.406 9.406 0 0 1 3 31.254a4.068 4.068 0 0 1 1.444.125 2.007 2.007 0 0 1 1.313 1.1 2.243 2.243 0 0 1 .179.758 6.907 6.907 0 0 1-.347 2.34q-.435 1.486-.834 2.982a5.435 5.435 0 0 0-.136.937 2.478 2.478 0 0 0 .03.589.673.673 0 0 0 .643.591 3.088 3.088 0 0 0 1.764-.247.231.231 0 0 1 .058 0c-.078.293-.152.578-.231.862a.165.165 0 0 1-.074.1c-.556.21-1.111.42-1.672.618a4.388 4.388 0 0 1-1.781.189 2.578 2.578 0 0 1-1.444-.517 1.941 1.941 0 0 1-.767-1.222A4.226 4.226 0 0 1 1.2 39c.188-1.019.542-1.993.8-2.993.153-.6.317-1.192.43-1.8a1.749 1.749 0 0 0-.083-1.073.635.635 0 0 0-.514-.365 3.057 3.057 0 0 0-1.74.213.588.588 0 0 1-.093.024",
    transform: "translate(0 -25.422)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 648",
    d: "M21.562 2.049A2.051 2.051 0 1 1 19.511 0a2.05 2.05 0 0 1 2.051 2.049",
    transform: "translate(-14.205)",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 332"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 249",
    style: {
      clipPath: "url(#3jjksgclmb)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 400",
    d: "M21.756 20.758a10.4 10.4 0 1 1-10.4-10.311 10.358 10.358 0 0 1 10.4 10.311",
    transform: "translate(-.1 -.247)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 401",
    d: "M13.482 22.721a.74.74 0 0 1-.743-.737v-1.84a.743.743 0 0 1 1.486 0v1.841a.74.74 0 0 1-.743.737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 402",
    d: "M16.082 21.616a.74.74 0 0 1-.743-.737v-1.84a.743.743 0 0 1 1.486 0v1.841a.74.74 0 0 1-.743.737"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 403",
    d: "M6.4 23.635c.727.657 1.042 1.486.707 1.85s-1.2.129-1.924-.528-1.043-1.486-.707-1.85 1.2-.129 1.924.528",
    transform: "translate(-.175 -.631)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 404",
    d: "M6.777 26.675c.727.657 1.043 1.486.707 1.85s-1.2.129-1.924-.528-1.043-1.486-.707-1.85 1.2-.129 1.924.528",
    transform: "translate(-.183 -.725)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 405",
    d: "M10.2 26.675c.727.657 1.043 1.486.707 1.85S9.7 28.654 8.979 28s-1.043-1.486-.707-1.85 1.2-.129 1.924.528",
    transform: "translate(-.259 -.725)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 406",
    d: "m6.269 2.421 3.715 6.26 4.087-6.629A5.755 5.755 0 0 0 9.984.948c-2.229.368-3.715.737-3.715 1.473",
    transform: "translate(-.217 .047)",
    style: {
      fill: "#00dd4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 407",
    d: "M11.424 9.206c-.156 0-.309.016-.465.023v-.391c.016-.023.036-.041.05-.065L14.451 2.7a.73.73 0 0 0 .067-.164 1.141 1.141 0 0 0 .153-.566C14.67.515 12.131 0 9.955 0S5.239.515 5.239 1.967a1.135 1.135 0 0 0 .154.565.736.736 0 0 0 .066.164L8.9 8.789a1.211 1.211 0 0 0 .2.256v.4a11.438 11.438 0 1 0 2.322-.236M9.955 1.473a7.7 7.7 0 0 1 3.033.493 7.69 7.69 0 0 1-3.033.494 7.684 7.684 0 0 1-3.032-.494 7.693 7.693 0 0 1 3.032-.493m-2.2 2.268a12.13 12.13 0 0 0 2.2.192 12.169 12.169 0 0 0 2.2-.191l-1.88 3.318a.373.373 0 0 1-.648 0zm3.669 26.269A9.467 9.467 0 0 1 9.1 11.341v.626a.929.929 0 0 0 1.857 0v-.9c.155-.007.308-.023.465-.023a9.482 9.482 0 1 1 0 18.964",
    transform: "translate(-.079 .074)",
    style: {
      fill: "#1a1e27"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 408",
    d: "M14.899 26.219a2.16 2.16 0 0 1-.768-.142 2.375 2.375 0 0 1-1.431-1.6.735.735 0 0 1 .511-.909.745.745 0 0 1 .918.507.918.918 0 0 0 .532.627.662.662 0 0 0 .6-.065c.23-.144.447-.28.447-1.18a.743.743 0 0 1 1.486 0 2.494 2.494 0 0 1-1.138 2.424 2.186 2.186 0 0 1-1.16.337"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.adfb1913e81dabb86bdbfb0407fd5a01.svg";
export { ForwardRef as ReactComponent };